/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Join_Success_RegistrationInputs */



/**
* | output |
* | --- |
* | "Successfully joined the organization!" |
*
* @param {Auth_Join_Success_RegistrationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_join_success_registration = /** @type {((inputs?: Auth_Join_Success_RegistrationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Join_Success_RegistrationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Registrierung erfolgreich! Du wirst weitergeleitet...")
	return /** @type {LocalizedString} */ ("Successfully joined the organization!")
});